export enum MessageBroker {
    RabbitMq = "RabbitMq",
    AzureServiceBus = "AzureServiceBus"
}